import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { ELEVATE_TOP_SHOP_V2 } from "@faire/web-api--source/indigofair/settings/ELEVATE_TOP_SHOP_V2";

export const getSettingElevateTopShopV2 = (): boolean =>
  getSettingValueWithoutAssignment(ELEVATE_TOP_SHOP_V2, false);
